import { Link, useLocation } from 'react-router-dom'
import { ChevronRight } from 'lucide-react'
import { sidebarNavItems, getActiveCategory } from '../utils/navigation'
import './Sidebar.css'

export default function Sidebar({ collapsed }) {
  const location = useLocation()
  const activeCategory = getActiveCategory(location.pathname)
  const navItems = sidebarNavItems[activeCategory] || []

  return (
    <aside className={`sidebar ${collapsed ? 'collapsed' : ''}`}>
      <nav className="sidebar-nav">
        {navItems.map(item => {
          const Icon = item.icon
          const isActive = location.pathname === item.path
          
          return (
            <Link
              key={item.id}
              to={item.path}
              className={`sidebar-item ${isActive ? 'active' : ''}`}
              title={collapsed ? item.label : ''}
            >
              <Icon size={20} />
              {!collapsed && (
                <>
                  <div className="sidebar-item-content">
                    <span className="sidebar-item-label">{item.label}</span>
                    <span className="sidebar-item-desc">{item.description}</span>
                  </div>
                  <ChevronRight size={16} className="sidebar-item-arrow" />
                </>
              )}
            </Link>
          )
        })}
      </nav>

      {!collapsed && navItems.length === 0 && (
        <div className="sidebar-empty">
          <p className="muted">No modules available for this section yet.</p>
        </div>
      )}
    </aside>
  )
}
